// src/components/layout/UserProfile.tsx
import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './UserProfile.css';

const UserProfile: React.FC = () => {
  const { user, signOut } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleSignOut = () => {
    signOut();
    navigate('/');
  };

  // Close the menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getInitials = (username: string) => {
    if (!username) return '';
    return username.charAt(0).toUpperCase();
  };

  const getImage = () => {
    if (!user) return '';
    // console.log(`\n\n\n --- Sending back User: ${JSON.stringify(user)}`)
    if (user.avatarUrl) {
      // console.log(`\n\n\n --- Sending back User's avatar_url: ${user.avatar_url}`)
      return user.avatarUrl;
    }
  };

  const shortenName = (name: string | undefined) => {
    if (!name) return '';
    return name.length > 10 ? name.substring(0, 10) + '...' : name;
  };

  return (
    <div className="user-profile" ref={menuRef}>
      <button className="profile-button deriq-action-button" onClick={toggleMenu}>
        <>
          {user?.avatarUrl? (
            <img src={getImage()} alt={user.name} className="profile-image" />
          ) : (
            <div className="profile-initials">{getInitials(user?.name ?? 'N/A')}</div>
          )}
          <span>{shortenName(user?.name)}</span>
        </>
      </button>
      {isMenuOpen && (
        <div className="profile-menu">
          <div className="profile-menu-header">
            <div className="profile-name">{user?.name}</div>
          </div>
          <Link to="/settings" className="menu-item">
            Settings
          </Link>
          <div className="menu-divider" />
          <button className="menu-item deriq-action-button" onClick={handleSignOut}>
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default UserProfile;
